// This file is generated.
export var version = '1.66.0';
//# sourceMappingURL=version.js.map